import {
    URLAPI,
    PERIODICITIES_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_periodicities: {
        data: [],
        status: 0,
        message: {},
    },
};

const GET_ALL_PERIODICITIES = "GET_ALL_PERIODICITIES";

export const periodicities_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_PERIODICITIES:
            return {
                ...state,
                _get_all_periodicities: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllPeriodicities = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${PERIODICITIES_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_PERIODICITIES,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_PERIODICITIES,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_PERIODICITIES,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};
